import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import Images from "../../../assets";

const AppliedUnivers = (props: any) => {
  // console.log(props);
  function formatDate(dateString: string, day: boolean): string {
    const options: Intl.DateTimeFormatOptions = day
      ? { year: "numeric", month: "long" }
      : { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }

  return (
    <div>
      {props?.data?.length > 0
        ? props?.data?.map((item: any) => (
            <Grid container spacing={4} sx={{ p: 2 }}>
              <Grid item xs={12} sx={{ }}>
                <Box
                  className="card"
                  sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}
                >
                  <Grid container>
                    <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                      <Typography
                        sx={{
                          minWidth: 150,
                          color: "#7C7A7A",
                          fontSize: "14px",
                        }}
                      >
                        University
                      </Typography>
                      <Typography>{item?.course?.university?.name}</Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                      <Typography
                        sx={{
                          minWidth: 150,
                          color: "#7C7A7A",
                          fontSize: "14px",
                        }}
                      >
                        Location
                      </Typography>
                      <Typography>
                        {/* {item?.university.location.city},{" "} */}
                        {item?.course?.university.location.state},{" "}
                        {item?.course?.university.location.country}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                      <Typography
                        sx={{
                          minWidth: 150,
                          color: "#7C7A7A",
                          fontSize: "14px",
                        }}
                      >
                        Course
                      </Typography>
                      <Typography>
                        {item?.course?.name} - {item?.course?.subDiscipline}
                      </Typography>
                    </Grid>
                    
                   
                    <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                      <Typography
                        sx={{
                          minWidth: 150,
                          color: "#7C7A7A",
                          fontSize: "14px",
                        }}
                      >
                        Study Level
                      </Typography>
                      <Typography>{item?.course.studyLevel}</Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                      <Typography
                        sx={{
                          minWidth: 150,
                          color: "#7C7A7A",
                          fontSize: "14px",
                        }}
                      >
                        Intake
                      </Typography>
                      <Typography>
                        {/* {new Date(item?.intake).toLocaleDateString()} */}
                        {formatDate(item?.intake, true)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                      <Typography
                        sx={{
                          minWidth: 150,
                          color: "#7C7A7A",
                          fontSize: "14px",
                        }}
                      >
                        Status
                      </Typography>
                      <Typography>{item?.status}</Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                      <Typography
                        sx={{
                          minWidth: 150,
                          color: "#7C7A7A",
                          fontSize: "14px",
                        }}
                      >
                        Stage
                      </Typography>
                      <Typography>{item?.stage}</Typography>
                    </Grid>
                    
                   
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          ))
        : 
        <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
              flexDirection: "column",
            }}
          >
            <img
              src={Images.noData}
              alt="noData"
              style={{ width: "70px", height: "70px", marginBottom: "1rem" }}
            />
            <Typography>No Products </Typography>
          </Box>}
    </div>
  );
};

export default AppliedUnivers;
